const KEY = "dp_lp_variant";
export const VARIANTS = ["A", "B", "C", "D"];
let cfg = {};
let started = false;

export const brl = (v) => (Number(v) || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

export function pickVariant(enabled) {
  const forced = new URLSearchParams(window.location.search).get("v")?.toUpperCase();
  if (VARIANTS.includes(forced)) { localStorage.setItem(KEY, forced); return forced; }
  if (enabled) localStorage.setItem("dp_lp_variants", JSON.stringify(enabled));
  const list = enabled || JSON.parse(localStorage.getItem("dp_lp_variants") || "null");
  if (!list) return null;
  const saved = localStorage.getItem(KEY);
  if (saved && list.includes(saved)) return saved;
  const v = list[Math.floor(Math.random() * list.length)] || "A";
  localStorage.setItem(KEY, v);
  return v;
}
export const getVariant = () => localStorage.getItem(KEY) || "A";

export function captureUtm() {
  const p = new URLSearchParams(window.location.search);
  const ref = (p.get("ref") || "").trim().toUpperCase();
  if (/^[A-Z0-9]{4,20}$/.test(ref)) sessionStorage.setItem("dp_ref", ref);
  const keys = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "gclid", "fbclid"];
  const found = Object.fromEntries(keys.filter((k) => p.get(k)).map((k) => [k, p.get(k)]));
  if (Object.keys(found).length) sessionStorage.setItem("dp_lp_utm", JSON.stringify({ ...found, referrer: document.referrer || "" }));
  else if (!sessionStorage.getItem("dp_lp_utm") && document.referrer) sessionStorage.setItem("dp_lp_utm", JSON.stringify({ referrer: document.referrer }));
}
export const getUtm = () => JSON.parse(sessionStorage.getItem("dp_lp_utm") || "{}");
export const getRef = () => sessionStorage.getItem("dp_ref") || "";

const addScript = (src) => { const s = document.createElement("script"); s.async = true; s.src = src; document.head.appendChild(s); };

export function initTracking(c) {
  if (started) return;
  started = true;
  cfg = c || {};
  const gid = cfg.ga_id || cfg.gads_id;
  if (gid && !window.gtag) {
    addScript(`https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(gid)}`);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() { window.dataLayer.push(arguments); }; // eslint-disable-line prefer-rest-params
    window.gtag("js", new Date());
    if (cfg.ga_id) window.gtag("config", cfg.ga_id, { variant: getVariant() });
    if (cfg.gads_id) window.gtag("config", cfg.gads_id);
  }
  if (cfg.meta_pixel_id && !window.fbq) {
    const f = function fbq() { f.callMethod ? f.callMethod.apply(f, arguments) : f.queue.push(arguments); }; // eslint-disable-line prefer-rest-params
    f.push = f; f.loaded = true; f.version = "2.0"; f.queue = []; window.fbq = f; window._fbq = f;
    addScript("https://connect.facebook.net/en_US/fbevents.js");
    window.fbq("init", cfg.meta_pixel_id); window.fbq("track", "PageView");
  }
  track("page_view");
}

export function track(event, params = {}) {
  const p = { ...params, variant: getVariant() };
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: `dp_${event}`, ...p });
  if (window.gtag && event !== "page_view") window.gtag("event", event, p);
  if (!window.fbq) return;
  if (event === "lead_success" || event === "vt_lead_success") window.fbq("track", "Lead", p);
  else if (event === "whatsapp_click") window.fbq("track", "Contact", p);
  else if (event !== "page_view") window.fbq("trackCustom", event, p);
  if (event === "lead_success" && window.gtag && cfg.gads_id && cfg.gads_label) window.gtag("event", "conversion", { send_to: `${cfg.gads_id}/${cfg.gads_label}` });
}

export const WA_TEXT = "Olá! Conheci a DPdigi e gostaria de entender como funciona o Departamento Pessoal Digital para minha empresa.";
export function waLink(num) {
  const d = String(num || "").replace(/\D/g, "");
  if (!d) return null;
  return `https://wa.me/${d.length <= 11 ? `55${d}` : d}?text=${encodeURIComponent(WA_TEXT)}`;
}
